import React from 'react';
import Modal from "src/shared-components/Modal";
import CloseIcon from "public/images/icons/close.svg";
import CreateRequest from "../CreateRequest";


type CreateRequestModalProps = {
  onClose: () => void;
}

const CreateRequestModal = React.forwardRef(
  ({ onClose }: CreateRequestModalProps, ref) => {
    return (
      <>
        <Modal ref={ref} maxHeight={false} closeOnBackdropClick={false}>
          <CloseIcon
            data-testid="close-icon"
            fill="#595959"
            onClick={onClose}
            className="inline cursor-pointer absolute right-5 top-5"
          />
          <CreateRequest onCompleted={onClose} />
        </Modal>
      </>
    )
  }
);

export default CreateRequestModal;
